import { z } from 'zod'

import { parseResponseErrorWithSchema } from '@/helpers/getApiErrorDetails'

const cartErrorBodySchema = z.object({
  errors: z.array(z.object({ type: z.string().optional(), reason: z.string().optional() })).catch([]),
})

export class CartNotFoundError extends Error {
  override name = 'CartNotFoundError'

  constructor(
    readonly cartId: string,
    options?: ErrorOptions
  ) {
    super(`Cart ${cartId} not found`, options)
  }
}

export const isCartNotFoundError = (error: unknown): error is CartNotFoundError => error instanceof CartNotFoundError

export const hasCartNotFoundBody = async (error: unknown) => {
  const body = await parseResponseErrorWithSchema(error, cartErrorBodySchema)

  return body?.errors.some(({ type, reason }) => type === 'CartError' && reason === 'notFound') ?? false
}

export const toCartError = async (error: unknown, cartId: string) =>
  (await hasCartNotFoundBody(error)) ? new CartNotFoundError(cartId, { cause: error }) : error
